import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    pointTitle: 'heading-m-regular',
    pointPrefix: 'capitalize',
    pointAddress: 'heading-s mt-1',
    pointCost: 'mt-3',
    pointDeliveryDate: 'mt-1',
    pointHeading: 'heading-s-regular mt-3',
    pointValue: 'heading-s mt-2',
    pointConfirm: 'mt-5 w-full',
    pointConfirmBtn: 'heading-m-regular w-full'
  },
  variants: {
    accent: {
      true: {
        pointCost: 'text-accent heading-s-regular',
        pointDeliveryDate: 'text-accent heading-s-regular'
      },
      false: {
        pointCost: 'heading-s',
        pointDeliveryDate: 'heading-s'
      }
    }
  }
});
